<div class="rating-view__nps-container">
  <div class="rating-view__scale-label">
    <span class="sub-label fs__sm">{{ question.minValueText }}</span>
    <span class="sub-label fs__sm">{{ question.maxValueText }}</span>
  </div>
  <mat-button-toggle-group [hideSingleSelectionIndicator]="true">
    @for (scale of [].constructor(11); track scale; let index = $index) {
      <mat-button-toggle [checked]="index === questionCtrl.value" [value]="index" (click)="onRate(index)">
        <span class="fs__md">{{ index }}</span>
      </mat-button-toggle>
    }
  </mat-button-toggle-group>
</div>
